'use client'

import {useEffect, useState} from 'react'
import {createClientComponentClient} from '@supabase/auth-helpers-nextjs'
import {User} from '@supabase/supabase-js'
import Link from 'next/link'
import { useRouter } from 'next/navigation'

export default function UserAuthDisplay() {
    const [user, setUser] = useState<User | null>(null)
    const [isLoading, setIsLoading] = useState(true)
    const supabase = createClientComponentClient()
    const router = useRouter()

    useEffect(() => {
        async function getUserSession() {
            const { data: {session} } = await supabase.auth.getSession()
            setUser(session?.user || null)
            setIsLoading(false)

            const {data: {subscription}} = supabase.auth.onAuthStateChange(
                (_event, session) => {
                    setUser(session?.user || null);
                }
            );

            return () => subscription.unsubscribe()
        }

        getUserSession()
    }, [supabase]);

    const handleSignOut = async () => {
        await supabase.auth.signOut()
        router.refresh()
    }

    if (isLoading) return null

    return (
        <div className="absolute top-4 right-4 z-10">
            {user ? (
                <div className="flex items-center gap-2 bg-[#1A1A1A] px-2 rounded-full">
                    <span className="text-sm text-white/80">
                        {user.email}
                    </span>
                    <button
                        onClick={handleSignOut}
                        className="text-sm text-white/60 hover:text-white"
                    >
                        Logout
                    </button>
                </div>
            ) : (
                <Link href="/auth/signin">
                    <button className="bg-white text-black px-4 py-2 rounded-full text-sm font-medium">
                        Login
                    </button>
                </Link>
            )}
        </div>
    )    
}




